import { customReporting } from "../../constants/apis/apiEndpoints";
import axiosInstance from "../../translator";

export const customFilterRequestApi = async () => {
  return axiosInstance
    .get(`${customReporting?.customFilterList}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
export const customReportRequestApi = async (urlParams, payload) => {
  return axiosInstance
    .post(`${customReporting?.customReport}${urlParams}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
